import { LayoutElementType as LET, LayoutElement, TaskFieldType as TFT } from "@models/layout-tpl";
import { RecursivePartial } from "@models/base/helper-types";

export const ctGantt: RecursivePartial<LayoutElement> = {
    type: LET.Box,
    flex: 1,
    minHeight: '30px',
    maxHeight: '30px',
    items: [
        {
            type: LET.Box,
            flex: 1,
            center: true,
            items: [
                {
                    type: LET.TaskField,
                    subType: TFT.Status,
                    noTitle: true
                },
                {
                    type: LET.TaskField,
                    subType: TFT.Priority,
                    margin: '0 8px 0 0',
                    vzSize: 'small'
                },
                {
                    type: LET.TaskField,
                    subType: TFT.Creator,
                    margin: '4px 0',
                    color: 'var(--vz-textColorL)',
                    size: 22,
                    userMode: 'icon',
                },
                {
                    type: LET.TaskField,
                    subType: TFT.AssignIcon,
                    fontSize: '16px',
                    padding: '5px 2px 3px 3px',
                    color: 'var(--vz-textColorL)',
                },
                {
                    type: LET.TaskField,
                    subType: TFT.Assignee,
                    margin: '4px 6px 4px 0',
                    color: 'var(--vz-textColorL)',
                    size: 22,
                    userMode: 'icon',
                },
            ]
        },
    ]
};
